<template>
  <div class="money-input">
      <InputNumber v-model="valueInput"
                  :active-change="false"
                  :disabled="disabled"
                  @on-blur="handleEmit">
      </InputNumber>
      <div class="ivu-input-group-append">
        <CurrencySelect v-model="currencySelected" :disabled="disableCurrency || disabled" @on-change="handleChange"></CurrencySelect>
      </div>
  </div>
</template>

<script>
import { intlCurrencyNumber, currencySymbols } from '@/libs/util'
import CurrencySelect from '@/components/currency'
export default {
  name: 'MoneyInput',
  components: {
    CurrencySelect
  },
  props: {
    currency: {
      type: String,
      required: false,
      default: 'CNY'
    },
    value: {
      type: [Number, String],
      required: false,
      default: 0
    },
    disableCurrency: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    prop: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      valueInput: this.value,
      currencySelected: this.currency || 'CNY'
    }
  },
  computed: {
    symbol: function () {
      return this.currencySymbols()[this.currencySelected]
    }
  },
  methods: {
    currencySymbols,
    intlCurrencyNumber,
    handleEmit: function () {
      this.$emit('input', this.valueInput)
      this.$emit('update:value', this.valueInput) // to be compatible with previews implementation
      this.$emit('update:currency', this.currencySelected)
      this.$emit('on-change', this.valueInput, this.currencySelected, this.prop)
    },
    handleChange (value) {
      this.currencySelected = value
      this.handleEmit()
    }
  },
  watch: {
    value: function (newVal) {
      if (newVal !== this.valueInput) {
        this.valueInput = newVal
      }
    },
    currency: function (newVal) {
      if (newVal) {
        this.currencySelected = newVal
      }
    }
  }
}
</script>

<style lang="less">
.value-edit {
  .ivu-icon-md-create {
    display: none;
  }
}
.value-edit:hover {
  .ivu-icon-md-create {
    display: inline-block;
  }
}
.money-input {
  width: 100%;
  display: flex !important;
  min-width: 200px;
  .ivu-input-number { border-top-right-radius: 0; border-bottom-right-radius: 0; min-width: 100px; }
  .ivu-input-group-append {
    padding: 0;
    min-width: 90px;
  }
  .ivu-select {
    margin: 0;
  }
}
</style>
